
import { type LucideProps } from "lucide-react"

export const Icons = {
  logo: (props: LucideProps) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 64 64"
      fill="none"
      {...props}
    >
      <g stroke="currentColor" strokeWidth="4" strokeLinecap="round">
        <line x1="16" y1="48" x2="32" y2="32" />
        <line x1="48" y1="48" x2="32" y2="32" />
        <line x1="20" y1="36" x2="32" y2="24" />
        <line x1="44" y1="36" x2="32" y2="24" />
        <line x1="24" y1="24" x2="32" y2="16" />
        <line x1="40" y1="24" x2="32" y2="16" />
        <line x1="32" y1="48" x2="32" y2="64" />
      </g>
    </svg>
  ),
  loggingTruck: (props: LucideProps) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 128 64"
      fill="currentColor"
      {...props}
    >
      <rect x="8" y="40" width="88" height="6" rx="2"/>
      <circle cx="24" cy="52" r="8"/>
      <circle cx="72" cy="52" r="8"/>
      <circle cx="104" cy="52" r="8"/>
      <rect x="14" y="18" width="4" height="22"/>
      <rect x="80" y="18" width="4" height="22"/>
      <rect x="18" y="30" width="62" height="6" rx="3"/>
      <rect x="18" y="24" width="62" height="6" rx="3"/>
      <rect x="18" y="18" width="62" height="6" rx="3"/>
      <circle cx="82" cy="21" r="3"/>
      <circle cx="82" cy="27" r="3"/>
      <circle cx="82" cy="33" r="3"/>
      <path d="M120 38h-22c-2 0-3-1-3-3v-7c0-1 0-2 1-3l6-6c1-1 2-1 3-1h10c2 0 3 1 4 3l2 6c1 2 1 3 1 5v9c0 2-1 3-2 3z"/>
      <path d="M106 23h10c1 0 2 1 2 2l1 4c0 1-1 2-2 2h-13v-6c0-1 1-2 2-2z" fill="white"/>
      <rect x="112" y="44" width="12" height="4"/>
    </svg>
  ),
  stackedLogs: (props: LucideProps) => (
    <svg 
      xmlns="http://www.w3.org/2000/svg" 
      viewBox="0 0 64 64"
      {...props}
    >
      <g fill="none" stroke="currentColor" strokeWidth="2">
        <circle cx="32" cy="20" r="8"/>
        <circle cx="32" cy="20" r="6"/>
        <circle cx="32" cy="20" r="4"/>
        <circle cx="32" cy="20" r="2"/>
      </g>
      <circle cx="32" cy="20" r="1" fill="currentColor"/>
    
      <g fill="none" stroke="currentColor" strokeWidth="2">
        <circle cx="20" cy="40" r="8"/>
        <circle cx="20" cy="40" r="6"/>
        <circle cx="20" cy="40" r="4"/>
        <circle cx="20" cy="40" r="2"/>
      </g>
      <circle cx="20" cy="40" r="1" fill="currentColor"/>
    
      <g fill="none" stroke="currentColor" strokeWidth="2">
        <circle cx="44" cy="40" r="8"/>
        <circle cx="44" cy="40" r="6"/>
        <circle cx="44" cy="40" r="4"/>
        <circle cx="44" cy="40" r="2"/>
      </g>
      <circle cx="44" cy="40" r="1" fill="currentColor"/>
    </svg>
  ),
  container: (props: LucideProps) => (
    <svg 
      xmlns="http://www.w3.org/2000/svg" 
      viewBox="0 0 128 128" 
      fill="none" 
      stroke="currentColor" 
      strokeWidth="2" 
      strokeLinecap="round" 
      strokeLinejoin="round"
      {...props}
    >
      <rect x="52" y="8" width="24" height="6" fill="currentColor" stroke="none"/>
      <path d="M64 14 v8" />
      <path d="M58 28 a6 6 0 0 1 12 0 v4 a6 6 0 0 1 -12 0 v-4" />
      <path d="M70 32 c0 4 -3 7 -6 9 s-6 5 -6 9" />
      <path d="M58 32 L24 44" />
      <path d="M70 32 L104 44" />
      <rect x="16" y="44" width="96" height="48" rx="2" />
      <line x1="24" y1="44" x2="24" y2="92" />
      <line x1="32" y1="44" x2="32" y2="92" />
      <line x1="40" y1="44" x2="40" y2="92" />
      <line x1="48" y1="44" x2="48" y2="92" />
      <line x1="56" y1="44" x2="56" y2="92" />
      <line x1="64" y1="44" x2="64" y2="92" />
      <line x1="72" y1="44" x2="72" y2="92" />
      <line x1="80" y1="44" x2="80" y2="92" />
      <line x1="88" y1="44" x2="88" y2="92" />
      <line x1="96" y1="44" x2="96" y2="92" />
      <circle cx="20" cy="48" r="1.5" fill="currentColor" stroke="none"/>
      <circle cx="108" cy="48" r="1.5" fill="currentColor" stroke="none"/>
    </svg>
  ),
}
